import { Avatar, Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import AR from '/@/components/country-menu/assets/AR.svg';
import BR from '/@/components/country-menu/assets/BR.svg';
import MX from '/@/components/country-menu/assets/MX.svg';
import PY from '/@/components/country-menu/assets/PY.svg';
import UY from '/@/components/country-menu/assets/UY.svg';
import { getSessionCountry, getUser } from '/@/store/session/selectors';

const ProfileIcon = () => {
    const user = useSelector(getUser);
    const country = useSelector(getSessionCountry);

    const flags = {
        AR,
        BR,
        MX,
        PY,
        UY,
    };
    return (
        <Avatar className='mp-mask' sx={{ background: '#F5F5F5', position: 'relative', overflow: 'visible' }}>
            <Typography variant='subtitle2' fontWeight='bold' color='primary'>
                {[user?.first_name?.charAt(0), user?.last_name?.charAt(0)].join('')}
            </Typography>
            <Box
                component='img'
                src={flags[country.code as keyof typeof flags]}
                sx={{ position: 'absolute', bottom: 0, right: 0, width: '16px', height: '16px' }}
            />
        </Avatar>
    );
};

export default ProfileIcon;
